class SeriesPageProductComparison extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.isInitialized = true;
    this.handleClick = this.handleClick.bind(this);
    this.handleImageError = this.handleImageError.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('error', this.handleImageError, true);

    this.querySelectorAll('[data-series-compare-product]').forEach((productCard) => {
      const activeSwatch = productCard.querySelector('[data-series-compare-swatch].is-active');
      if (activeSwatch) this.selectSwatch(activeSwatch);
    });
  }

  handleClick(event) {
    const swatch = event.target.closest('[data-series-compare-swatch]');
    if (!swatch || !this.contains(swatch)) return;

    this.selectSwatch(swatch);
  }

  selectSwatch(swatch) {
    const productCard = swatch.closest('[data-series-compare-product]');
    const image = productCard?.querySelector('[data-series-compare-image]');
    const imageSrc = swatch.dataset.imageSrc;

    if (!productCard || !image || !imageSrc) return;

    productCard.querySelectorAll('[data-series-compare-swatch]').forEach((button) => {
      const isActive = button === swatch;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    image.dataset.variantActive = 'true';
    image.src = imageSrc;
    image.srcset = swatch.dataset.imageSrcset || '';
    image.alt = swatch.dataset.imageAlt || image.dataset.fallbackAlt || '';
  }

  handleImageError(event) {
    const image = event.target.closest('[data-series-compare-image]');
    if (!image || image.dataset.variantActive !== 'true') return;

    image.dataset.variantActive = 'false';
    image.srcset = '';
    image.src = image.dataset.fallbackSrc;
    image.alt = image.dataset.fallbackAlt || '';
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('error', this.handleImageError, true);
    this.isInitialized = false;
  }
}

if (!customElements.get('series-page-product-comparison')) {
  customElements.define('series-page-product-comparison', SeriesPageProductComparison);
}